import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import { Translate } from '@hydra/common/components';
import ConfirmDialog from '@hydra/routes/account/routes/security/components/ConfirmDialog';

const useStyles = makeStyles(theme => ({
  deleteButton: {
    color: theme.palette.error.main
  }
}));
interface ActionsInterface {
  onDelete: () => void
}
export default function Actions ({ onDelete }: ActionsInterface) {
  const classes = useStyles();
  const [deleteDialog, setDeleteDialog] = useState(false);

  function handleDeleteButtonClick () {
    setDeleteDialog(true);
  }
  return (
    <>
      <ConfirmDialog open={deleteDialog} setOpen={setDeleteDialog} deleteMethod={onDelete} />
      <Button
        size='small'
        className={classes.deleteButton}
        onClick={handleDeleteButtonClick}
      >
        <Translate content='account_security_logout_session' />
      </Button>
    </>
  );
}
